{
  "name": "@ns/company-find-or-create",
  "version": "1.0.0",
  "description": "Find a company to job or create a new one if it doesn't exist.",
  "inputs": {
    "company": {
      "type": "string"
    },
    "invitationId": {
      "type": "string"
    }
  },
  "outcomes": {
    "join": {},
    "created": {}
  },
  "jobMetadata": [
    "CREATED_COMPANY"
  ]
}
